export const sortElements = (arr) => {
  return arr?.sort((obj1, obj2) => {
    const name1 = obj1.name ? obj1.name.toUpperCase() : ''
    const name2 = obj2.name ? obj2.name.toUpperCase() : ''

    if (name1 < name2) return -1
    if (name1 > name2) return 1
    return 0
  })
}

export const isMessageNotified = (messageId, notifications) => {
  if (!Array.isArray(notifications)) return false
  return notifications?.some(notification => {
    const comment = notification.activity.comment
    return comment.id === messageId || comment.parent_comment_id === messageId
  })
}

export const capitalizeFirst = (msg) => {
  if (!msg) return ''
  return msg.charAt(0).toUpperCase() + msg.slice(1)
}
